import { queryClient } from '@/integrations/react-query'
import { fetchCaseById, updateCaseStatus as updateStatus } from '@/services/cases'
import { EstimateStatus } from '@backend/schemas'
import { useQuery } from '@tanstack/react-query'

const keyGenerator = (id: string) => ['cases', id] as const

export const useCaseDetail = (id: string) => {
  return useQuery({
    queryKey: keyGenerator(id),
    queryFn: () => fetchCaseById(id),
    enabled: !!id,
  })
}

export const updateCaseStatus = async (id: string, status: EstimateStatus, message?: string) => {
  const response = await updateStatus(id, status, message)
  queryClient.setQueryData(keyGenerator(id), response)
}

useCaseDetail.invalidate = (id: string) => {
  queryClient.invalidateQueries({ queryKey: keyGenerator(id) })
}
